import { Component, Input } from '@angular/core'

@Component({
  selector: 'message',
  templateUrl: './message.component.pug',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  @Input('class') className: string
  @Input() icon?: string

  get iconClass (): string {
    return this.icon ?? {
      danger: 'fa-exclamation-triangle',
      warning: 'fa-exclamation-triangle',
      info: 'fa-lightbulb-on',
      success: 'fa-check',
    }[this.className] ?? ''
  }
}
